var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('BannerStockClub',{attrs:{"fanpush":_vm.fanpush}}),_c('VotacaoFanpush',{attrs:{"fanpush":_vm.fanpush}}),_c('DestaquesBeneficios'),_c('Bastidores'),_c('PesquisaUsuario')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }